import { useEffect, useRef, useState } from "react";
//import "./iftarExchangeLive.css";
import axios from "axios";
import LanguageSwitch from "./dropdownLanguage";
import usePhaseMobileRedirect from "./usePhaseMobileRedirect";

const PROMPTS = [
  {
    id: 1,
    phase: "Panel 1",
    question:
      "In one sentence: what is the single biggest factor in your next infrastructure investment decision in Indonesia?",
    type: "text",
  },
  {
    id: 2,
    phase: "Panel 2",
    question:
      "If this corridor had one infrastructure improvement in 12 months, what should it be?",
    type: "choice",
    options: [
      "Carrier-neutral exchange point (local peering)",
      "Dark fiber metro ring connecting estates",
      "Cloud on-ramps (AWS / Azure / GCP)",
      "Higher power density & liquid cooling",
      "Unified regulatory framework across estates",
      "Something else (tell us below)",
    ],
  },
  {
    id: 3,
    phase: "Dinner",
    question: "What surprised you tonight?",
    type: "text",
  },
];

const TEXT = {
  en: {
    openThoughts: "Open Thoughts",
    description:
      "Share your thoughts, reactions, or questions at any time. The AI reads all inputs and synthesizes them into collective insights — your individual response is never shown publicly.",
    placeholder: "What's on your mind?",
    send: "Send",
    sending: "Sending...",
    received:
      "✓ Received — your insights has been shared with the room and the AI moderator",
    footerLeft: "Anonymous · AI-synthesized",
    footerRight: "", //"52 voices active"
    title: "We Value Your Insights",
    subtitle: "Anonymous · AI-synthesized · Shared collectively",
    language: "Language",
  },

  id: {
    openThoughts: "Pandangan Anda",
    description:
      "Silakan berikan pemikiran, tanggapan, atau pertanyaan Anda kapan saja. AI akan membaca setiap masukan dan merangkumnya menjadi wawasan bersama — respons pribadi Anda tidak akan ditampilkan secara publik.",
    placeholder: "Apa yang ingin Anda sampaikan?",
    send: "Kirim",
    sending: "Sedang mengirim...",
    received:
      "✓ Diterima — pesan Anda telah diberikan dan sudah diterima oleh moderator AI",
    footerLeft: "Anonim · Dirangkum oleh AI",
    footerRight: "", //"52 voices active"
    title: "Sampaikan Pandangan Anda",
    subtitle: "Anonim · Dirangkum oleh AI · Dibagikan secara kolektif",
    language: "Bahasa",
  }
};

export default function IftarExchangeAdmin() {
  usePhaseMobileRedirect();
  const [activeTab, setActiveTab] = useState("pulse");
  const [thought, setThought] = useState("");
  const [submitted, setSubmitted] = useState([]);
  const [promptResponses, setPromptResponses] = useState({});
  const [selectedChoices, setSelectedChoices] = useState({});
  const [showConfirm, setShowConfirm] = useState(false);
  const [activePromptIdx, setActivePromptIdx] = useState(1);
  const [promptTexts, setPromptTexts] = useState({});
  const [message, setMessage] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState("en");
  const t = TEXT[language];
  const [time, setTime] = useState(
    new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
  );

  const textareaRef = useRef(null);

  const handleChange = (e) => {
    const el = textareaRef.current;
    setThought(e.target.value);

    el.style.height = "auto"; // reset
    el.style.height = el.scrollHeight + "px"; // grow sesuai isi
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(
        new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
      );
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  const handleSubmitThought = async () => {
    if (!thought.trim()) return;

    setLoading(true);
    setMessage(null);
    setErrorMsg(null);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_PATH_DESTINATION}/iftarExchange2026Admin`,
        {
          question: thought,
        }
      );

      if (res.data) {
        setMessage(t.received);

        setSubmitted([
          ...submitted,
          {
            text: thought,
            time: new Date().toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            }),
          },
        ]);

        setThought("");
        setShowConfirm(true);
        setTimeout(() => setShowConfirm(false), 3000);
      }
    } catch (err) {
      console.error(err);

      setErrorMsg(
        err.response?.data?.error || "Something went wrong while sending"
      );
    }

    setLoading(false);
  };

  const handlePromptSubmit = (promptId, value) => {
    setPromptResponses({ ...promptResponses, [promptId]: value });
  };

  const toggleChoice = (promptId, option) => {
    const current = selectedChoices[promptId] || [];
    if (current.includes(option)) {
      setSelectedChoices({
        ...selectedChoices,
        [promptId]: current.filter((o) => o !== option),
      });
    } else {
      setSelectedChoices({
        ...selectedChoices,
        [promptId]: [...current, option],
      });
    }
  };

  return (
    <div className="app">
      <div className="header">

        <div className="banner-wrapper">

          <img
            src="/dist/img/IftarExchangeBanner.png"
            alt="Iftar Exchange 2026"
            className="banner-img"
          />

          <div className="status-bar">
            {/* <span className="status-time">{time}</span> */}

            <div className="language-switch">
              <LanguageSwitch language={language} setLanguage={setLanguage} />
            </div>
          </div>

        </div>

        <div className="header-content">
          <div className="live-label">LIVE</div>
          <div className="main-title">{t.title}</div>
          <div className="subtitle">{t.subtitle}</div>
        </div>

      </div>

      <div className="tab-bar">
        <button
          className={activeTab === "pulse" ? "tab active" : "tab"}
          onClick={() => setActiveTab("pulse")}
        >
          {t.openThoughts}
        </button>

        {/* <button
          className={activeTab === "prompts" ? "tab active" : "tab"}
          onClick={() => setActiveTab("prompts")}
        >
          Live Prompts <span className="live-dot" />
        </button> */}
      </div>

      <div className="content">
        {/* ===== PULSE ===== */}
        {activeTab === "pulse" && (
          <>
            <div className="description">
              {t.description}
            </div>

            <div className="textarea-wrapper">
              <textarea
                ref={textareaRef}
                value={thought}
                onChange={handleChange}
                placeholder={t.placeholder}
                className="textarea"
              />

              <button
                onClick={handleSubmitThought}
                disabled={!thought.trim() || loading}
                className="send-btn"
              >
                {loading ? t.sending : t.send}
              </button>
            </div>

            {showConfirm && (
              <>
                {message && (
                  <div className="confirm-box">
                    {message}
                  </div>
                )}
              </>
            )}

            {showConfirm && (
              <>
                {errorMsg && (
                  <div className="error-box">
                    ⚠ {errorMsg}
                  </div>
                )}
              </>
            )}

            {/* {showConfirm && (
              <div className="confirm-box">
                ✓ Received — your question has been shared with the room and the AI moderator
              </div>
            )} */}

            {/* {submitted.length > 0 && (
              <div className="submission-list">
                {submitted.map((s, i) => (
                  <div key={i} className="submission-item">
                    <div>{s.text}</div>
                    <div className="submission-time">
                      Sent at {s.time}
                    </div>
                  </div>
                ))}
              </div>
            )} */}

            {/* <div className="room-temp">
              <div className="room-temp-title">
                LATEST ROOM TEMPERATURE
              </div>
              <div className="room-temp-text">
                {ROOM_TEMPS[2].text}
              </div>
              <div className="room-temp-meta">
                {ROOM_TEMPS[2].time} · {ROOM_TEMPS[2].responses} voices
              </div>
            </div> */}
          </>
        )}

        {/* ===== PROMPTS ===== */}
        {activeTab === "prompts" && (
          <>
            <div className="prompt-selector">
              {PROMPTS.map((pr, i) => (
                <button
                  key={pr.id}
                  onClick={() => setActivePromptIdx(i)}
                  className={
                    activePromptIdx === i
                      ? "prompt-pill active"
                      : "prompt-pill"
                  }
                >
                  {pr.phase}
                </button>
              ))}
            </div>

            {(() => {
              const pr = PROMPTS[activePromptIdx];
              const responded = promptResponses[pr.id];

              return (
                <div>
                  <div className="prompt-box">
                    <div className="prompt-phase">
                      {pr.phase.toUpperCase()} — QUESTION
                    </div>
                    <div className="prompt-question">
                      {pr.question}
                    </div>
                  </div>

                  {responded ? (
                    <div className="responded-box">
                      ✓ Response submitted
                    </div>
                  ) : pr.type === "text" ? (
                    <div>
                      <textarea
                        className="textarea"
                        placeholder="Your response..."
                        value={promptTexts[pr.id] || ""}
                        onChange={(e) =>
                          setPromptTexts({
                            ...promptTexts,
                            [pr.id]: e.target.value,
                          })
                        }
                      />
                      <button
                        className="submit-btn"
                        onClick={() => {
                          const val = promptTexts[pr.id] || "";
                          if (val.trim())
                            handlePromptSubmit(pr.id, val.trim());
                        }}
                      >
                        Submit Response
                      </button>
                    </div>
                  ) : (
                    <div>
                      {pr.options.map((opt, oi) => {
                        const sel = (
                          selectedChoices[pr.id] || []
                        ).includes(opt);

                        return (
                          <button
                            key={oi}
                            onClick={() =>
                              toggleChoice(pr.id, opt)
                            }
                            className={
                              sel
                                ? "choice-btn selected"
                                : "choice-btn"
                            }
                          >
                            {opt}
                          </button>
                        );
                      })}

                      <button
                        className="submit-btn"
                        disabled={
                          !(selectedChoices[pr.id] || [])
                            .length
                        }
                        onClick={() => {
                          const choices =
                            selectedChoices[pr.id] || [];
                          if (choices.length > 0)
                            handlePromptSubmit(
                              pr.id,
                              choices
                            );
                        }}
                      >
                        Submit Selection
                      </button>
                    </div>
                  )}
                </div>
              );
            })()}
          </>
        )}
      </div>

      <div className="footer">
        <span>{t.footerLeft}</span>
        <span>{t.footerRight}</span>
      </div>
    </div>
  );
}